/*
Item: prepared WaitDialog Component waiting
Name: WaitDialog
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
// import { TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Messages } from 'primereact/messages';
// import { Panel } from 'primereact/components/panel/Panel';
import { DropdownLabeled } from './DropdownLabeled';
import MessageService from '../service/MessageService';
import { RightNames } from '../utils/statisticsUtils';
import {
  hasPermission, actions, returnUserRights,
} from '../utils/roleUtils';

const DialogType = Object.freeze({
  none: 0,
  releaseToAll: 1,
  releaseGroup: 2,
  releaseToOffice: 3,
});

const info = [
  {
    character: '*',
    description: 'Entspricht einer beliebigen Anzahl von Zeichen. Sie können das Sternchen (*) überall in einer Zeichenkette verwenden.',
    example: 'M*er findet Müller, Miller, Maler und Meister, aber nicht Motor oder Meyr',
  },
  {
    character: '?',
    description: 'Entspricht einem einzelnen Zeichen an einer bestimmten Stelle.',
    example: 'B?ll findet Ball, Bell und Bill',
  },
];

const rowsPerPage = 30;

class PanelView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // state for current page report template
      first: props.first || 0,
      last: 9,
      rows: 10,
      // state for search bar
      searchCriterion: { name: 'Bezeichnung', value: 'Bezeichnung' },
      searchText: '',
      // state for sorting
      sortCriterion: 'Bezeichnung',
      sortDirection: 'ASC',
      sortingSelection: {
        Name: 'ASC',
        Beschreibung: '',
        Klassifikationsschlüssel: '',
      },
      // all users Data to show the table
      /*
      entryProperties: [
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
        {
          name: '',
          longtext: '',
          statisticName: '',
        },
      ],
      */
    };
    this.messageService = new MessageService();
    this.onPage = this.onPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleVisible = this.handleVisible.bind(this);
    this.handleUserData = this.handleUserData.bind(this);
  }

  handleChange(node, type) {
    this.props.onValueChange(node, type);
  }

  handleVisible(visibleWait) {
    this.props.onVisibility(visibleWait);
  }

  handleUserData(index, list) {
    this.props.onUserData(index, list);
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      const { searchText, rows } = this.state;
      return this.handleSearch(searchText, rows);
    }
    return Promise.resolve();
  }

  onSelectChange = (e) => {
    this.setState({ searchCriterion: e.value });
  }

  handleSearch(searchText, rows) {
    this.props.onPage(0, rows, searchText);
    this.setState({ first: 0 });
  }

  onPage(event, totalRecords) {
    const { first, rows } = event;
    this.setState({
      first: parseInt(first, 10),
      last: parseInt(first, 10) + rows < totalRecords
        ? parseInt(first, 10) + rows - 1
        : totalRecords - 1,
      rows: event.rows,
    });
  }

  selectSorting(newSortCriterion, reset) {
    const { sortCriterion, sortDirection, sortingSelection } = this.state;
    let newSortDirection;
    if (!reset) {
      // set selection states:
      if (sortCriterion === newSortCriterion) {
        // search criterion remains unchanged -> change sort direction
        newSortDirection = sortDirection === 'DESC' ? 'ASC' : 'DESC';
      } else {
        // other search criterion -> change sort direction to ascending
        newSortDirection = 'DESC';
      }
    }
    sortingSelection[newSortCriterion] = newSortDirection;
    this.setState({ sortDirection: newSortDirection });
    this.setState({ sortCriterion: newSortCriterion });
    this.setState({ sortingSelection }, () => this.loadList(null, 'TOP', null, rowsPerPage));
  }

  async loadList(returnMessage, direction, entryArg, maxRowsPerPage) {
    let entry;
    if (entryArg === null) {
      entry = entryArg;
    } else {
      entry = entryArg// .rightObject;
    }
    this.handleVisible(true);
    const { index, typeString } = this.props;
    // Anzahl der Einträge <= 30?
    // dann lade neue Einträge für gleiche Freigabe
    const {
      sortCriterion, sortDirection, searchCriterion, searchText,
    } = this.state;
    // replacing postRecordStructureDirectory1
    const right = (index === 0 || index === 2 || index === 4) ? 'BENGRP' : 'GRP';
    const listData = await this.messageService.postList(
      returnMessage,
      direction,
      entry,
      maxRowsPerPage,
      sortCriterion,
      sortDirection,
      searchCriterion.value,
      searchText,
      typeString,
      right,
    );
    this.setState({first: 0})
    if (listData.entrys) {
      if (listData.entrys.length > 0) {
        // an 'props' zurückgeben mit Methodenaufruf
        this.handleUserData(index, listData.entrys);
      } else {
        this.showMessage('Es wurden keine weiteren Einträge gefunden.', 'info');
      }
    }
    if (listData[1] === 'error') {
      this.showMessage(listData[0], 'error');
      // reset search criteria
      this.setState({ searchText: '' });
      // start default search
    }
    this.handleVisible(false);
  }

  // shows a Message at the top of the table
  showMessage(messageDetail, messageSeverity) {
    const msg = {
      life: 5000,
      severity: messageSeverity,
      detail: messageDetail,
    };
    this.messages.show(msg);
  }

  clearSearch() {
    const { rows } = this.state;
    this.setState({ searchText: '', searchCriterion: { name: 'Name', value: 'Name' } }, () => {
      this.handleSearch(null, rows);
    });
  }

  makeHeaderCell(criterionName, text, sortable) {
    const { sortingSelection, sortCriterion } = this.state;
    const lookup = sortingSelection[criterionName];
    let retColor;
    let retClass;
    if (criterionName !== sortCriterion) {
      retClass = 'p-sortable-column-icon pi pi-fw pi-sort';
      retColor = 'grey';
    } else {
      retColor = 'black';
      if (lookup === 'ASC') {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-up';
      } else {
        retClass = 'p-sortable-column-icon pi pi-fw pi-sort-down';
      }
    }
    const sortingClass = retClass;
    let ret = (
      <th style={{ cursor: 'pointer', color: retColor }} onClick={() => this.selectSorting(criterionName)}>
        {text}
        <span className={sortingClass} />
      </th>
    );
    if (!sortable) {
      ret = (
        <th style={{ color: retColor }}>
          {text}
          <span />
        </th>
      );
    }
    return ret;
  }

  actionTemplate(doc) {
    const userRights = returnUserRights();
    return (
      <div>
        <Button
          // Für alle Admins (im Benutzer-Tab) erlaubt
          disabled={(doc.rights === 'GRP') && hasPermission(userRights, actions.ReleasePersonalToGroup)}
          title="Gruppenintern freigeben"
          type="button"
          icon="pi-md-group"
          className="p-button-success"
          onClick={() => this.handleChange(doc, DialogType.releaseGroup)}
        />
        <Button
          // Nur für Bundesamt Fachadmin erlaubt (im Benutzer- und Gruppen-Tab)
          disabled={!hasPermission(userRights, actions.ReleasePersonalToTransfer)}
          title="Amtsintern freigeben"
          type="button"
          icon="pi-md-location-city"
          className="p-button-success"
          onClick={() => this.handleChange(doc, DialogType.releaseToOffice)}
        />
        <Button
          // Nur für Bundesamt Fachadmin erlaubt (Benutzer- und Gruppen-Tab)
          disabled={!hasPermission(userRights, actions.ReleasePersonalToTransfer)}
          title="Öffentlich freigeben"
          type="button"
          icon="pi-md-language"
          className="p-button-success"
          onClick={() => this.handleChange(doc, DialogType.releaseToAll)}
        />
      </div>
    );
  }

  renderList(entryList) {
    const docType = 6;
    const { searchText } = this.state;
    if (!entryList) return null;
    const { first, rows } = this.state;
    const last = first + rows < this.props.totalRecords ? first + rows : this.props.totalRecords
    const pageTemplate = `${first + 1} bis ${last} von ${this.props.totalRecords} Einträgen`;
    const docs = [...entryList].map((entry) => {
      return {
        docType,
        _id: `${docType}ID${entry.id}`,
        name: entry.rightObject.name,
        rights: entry.rightObject.ownerInfo.rightArea,
        rightName: RightNames[entry.rightObject.ownerInfo.rightArea],
        owner: entry.rightObject.ownerInfo.user,
        group: entry.rightObject.ownerInfo.groupReference.name,
        id: entry.rightObject.id,
        entry,
      };
    });

    return (
      <DataTable
        value={docs}
        paginator
        emptyMessage="Keine Einträge vorhanden"
        paginatorPosition="both"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        rows={rows}
        rowsPerPageOptions={[5, 10, 20, 30]}
        totalRecords={this.props.totalRecords}
        resizableColumns
        currentPageReportTemplate={pageTemplate}
        onPage={(e) => {
          this.props.onPage(e.first, e.rows, searchText);
          this.setState({rows: e.rows, first: e.first });
        }}
        first={first}
        lazy
      >
        <Column field="name" header="Bezeichnung" style={{ width: '20%' }} />
        <Column field="owner" header="Benutzer" style={{ width: '20%' }} />
        <Column field="group" header="Gruppe" style={{ width: '15%' }} />
        <Column header="Aktionen" body={(obj) => this.actionTemplate(obj)} style={{ textAlign: 'center', width: '6em' }} />
      </DataTable>
    );
  }

  render() {
    const {
      // searchCriterion,
      searchText, rows,
    } = this.state;
    const {
      userData,
    } = this.props;
    const selectionList = [
      { name: 'Bezeichnung', value: 'Bezeichnung' },
    ];
    return (
      <Card>
        <Messages
          ref={(el) => { this.messages = el; }}
          style={{ marginBottom: '1em' }}
        />
        <div className="p-grid">
          <DropdownLabeled
            disabled
            label="Selektionskriterium"
            customClass="p-col-3"
            id="criterion"
            value={selectionList[0]}
            options={selectionList}
            onChange={this.onSelectChange}
            optionLabel="name"
          />
          <div className="p-col-4">
            <span style={{
              fontSize: '12px',
            }}
            >
              &nbsp;
            </span>
            <span className="p-float-label">
              <InputText
                id="search-input"
                type="text"
                size="33"
                value={searchText}
                onKeyDown={(e) => this.handleKeyDown(e)}
                onChange={(e) => this.setState({ searchText: e.target.value })}
              />
              <label htmlFor="search-input">Suchtext</label>
            </span>
          </div>
          <OverlayPanel ref={(el) => { this.op = el; }} showCloseIcon dismissable>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <p>Im Suchtext können Sie die Platzhalter '?' und '*'' benutzen:</p>
            <DataTable style={{ width: '48em' }} value={info}>
              <Column style={{ width: '8em' }} field="character" header="Zeichen" />
              <Column style={{ width: '20em' }} field="description" header="Beschreibung" />
              <Column style={{ width: '20em' }} field="example" header="Beispiel" />
            </DataTable>
          </OverlayPanel>
          <div className="p-col-5">
            <Button
              title="Hinweise zur Suche"
              type="button"
              id="info"
              onClick={(e) => this.op.toggle(e)}
              icon="pi pi-md-info-outline"
            />
            <Button
              type="button"
              id="search"
              label="Suchen"
              onClick={() => this.handleSearch(searchText, rows)}
            />
            <Button
              type="button"
              id="clear"
              className="p-button-primary"
              label="Zurücksetzen"
              onClick={() => this.clearSearch()}
            />
          </div>
        </div>
        <div className="p-col-12 global-sales" style={{ padding: '0px' }}>
          {this.renderList(userData)}
        </div>
      </Card>
    );
  }
}

export default PanelView;

PanelView.propTypes = {
  typeString: PropTypes.instanceOf(String).isRequired,
  onValueChange: PropTypes.func.isRequired,
  onVisibility: PropTypes.func.isRequired,
  onUserData: PropTypes.func.isRequired,
  index: PropTypes.instanceOf(Number).isRequired,
};
